module.exports = __webpack_public_path__ + "static/gallery_06-thumb-ed54d725f58a85928210a33077289b9e.jpg";